<!--component html goes here -->
<input #textbox type="text" maxlength="64" class="barcode-input" style="width: 100%" [(ngModel)]="textValue" />

<on-screen-keyboard [keyboardType]="keyboardType" (keyPress)="keyPress($event)"></on-screen-keyboard>
